module.exports = __webpack_public_path__ + "img/banner.32d83c28.jpg";